'use client';
import { useState } from "react";

const WorksForSection = () => {
  const teams = [
    "🚀 Startups",
    "📋 Project Managers",
    "🏢 Agencies",
    "🌍 Remote Teams",
    "🎓 Student Teams",
    "💻 Engineering",
    "🎨 Design Teams",
    "📈 Product Teams",
    "💰 Sales Teams",
    "👥 HR Teams",
    "📊 Finance Teams",
    "🎯 Marketing Teams",
    "🛎️ Customer Success",
    "📦 Operations Teams",
    "⚖️ Legal Teams",
    "⏰ Freelancers",
    "🤝 Cross-functional Teams",
    "📍 Hybrid Teams",
    "🌐 Global Teams",
  ];

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="solutions" className="py-[120px] px-6 max-w-[1100px] mx-auto text-center">
      <div className="text-xs font-bold uppercase tracking-[0.12em] text-primary mb-3.5">
        WORKS FOR
      </div>
      <h2 className="font-display font-black leading-[1.05] tracking-[-0.04em]" style={{ fontSize: 'clamp(32px, 4.5vw, 52px)' }}>
        Works for <span className="gradient-text">any team type</span>
      </h2>

      <div className="flex gap-3 flex-wrap justify-center mt-12">
        {teams.map((team, i) => (
          <div
            key={team}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
            className={`
              relative px-7 py-3.5 rounded-full font-display text-[15px] font-bold
              transition-all duration-300 cursor-default border
              overflow-hidden select-none
              ${hoveredIndex === i
                ? "border-primary text-primary-foreground scale-110 z-10"
                : "bg-card border-border"
              }
            `}
            style={hoveredIndex === i ? {
              background: "linear-gradient(135deg, hsl(263,84%,55%), hsl(271,91%,65%), hsl(20,100%,55%))",
              boxShadow: "0 0 24px 4px rgba(124,58,237,0.4), 0 0 60px 8px rgba(255,100,30,0.25), 0 4px 20px rgba(0,0,0,0.15)",
              animation: "fireGlow 0.4s ease-out",
            } : undefined}
          >
            {hoveredIndex === i && (
              <span
                className="absolute inset-0 rounded-full pointer-events-none"
                style={{
                  background: "radial-gradient(circle at 50% 50%, rgba(255,200,100,0.3) 0%, transparent 70%)",
                  animation: "firePulse 1.2s ease-in-out infinite",
                }}
              />
            )}
            <span className="relative z-10">{team}</span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes fireGlow {
          0% { transform: scale(1); filter: brightness(1); }
          30% { transform: scale(1.18); filter: brightness(1.4); }
          100% { transform: scale(1.1); filter: brightness(1.1); }
        }
        @keyframes firePulse {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
      `}</style>
    </section>
  );
};

export default WorksForSection;
